import { RC1, RC2, RC3, RC4 } from '@/theme/colors';

export const fields = [
  {
    id: '1',
    name: 'Safety',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_safety_cof',
  },
  {
    id: '2',
    name: 'Environment',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_environment_cof',
  },
  {
    id: '3',
    name: 'Public Impact',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_public_impact_cof',
  },
  {
    id: '4',
    name: 'Direct Cost',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_direct_cost_cof',
  },
  {
    id: '5',
    name: 'Business Loss',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_business_loss_cof',
  },
  {
    id: '6',
    name: 'Structure Type',
    displayInRisk: true,
    displayInQuery: false,
    options: ['Breasting Dolphin', 'Mooring Dolphin'],
    key: 'risk_level_1_component',
  },
  {
    id: '7',
    name: 'General Comments',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_general_comments_cof',
  },
  {
    id: '8',
    name: 'Damage Class',
    displayInRisk: false,
    displayInQuery: false,
    options: ['DC1', 'DC2', 'DC3', 'DC4', 'DC5'],
    key: 'risk_damage_class',
  },
  {
    id: '9',
    name: 'Safety',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_safety_pof',
  },
  {
    id: '10',
    name: 'Environment',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_environment_pof',
  },
  {
    id: '11',
    name: 'Public Impact',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_public_impact_pof',
  },
  {
    id: '12',
    name: 'Direct Cost',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_direct_cost_pof',
  },
  {
    id: '13',
    name: 'Business Loss',
    displayInRisk: false,
    displayInQuery: false,
    key: 'risk_business_loss_pof',
  },
  {
    id: '14',
    name: 'General Comments',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_general_comments_pof',
  },
  {
    id: '15',
    name: 'Coating System',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_coating_system',
  },
  {
    id: '16',
    name: 'Corrosivity Category',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_corrosivity_category',
  },
  {
    id: '17',
    name: 'Structure Age',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_structure_age',
  },
  {
    id: '18',
    name: 'Cathodic Protection',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_cathodic_protection',
  },
  {
    id: '19',
    name: 'Transition Period',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_transition_period',
  },
  {
    id: '20',
    name: 'General Comments',
    displayInRisk: false,
    displayInQuery: false,
    options: [],
    key: 'risk_general_comments_transition_period',
  },
];

export const riskFields = [
  {
    id: '11',
    fieldKey: 'risk_safety_cof',
    type: ['COF'],
    isHiddenColumn: false,
  },
  {
    id: '22',
    fieldKey: 'risk_environment_cof',
    type: ['COF'],
    isHiddenColumn: false,
  },
  {
    id: '33',
    fieldKey: 'risk_public_impact_cof',
    type: ['COF'],
    isHiddenColumn: false,
  },
  {
    id: '44',
    fieldKey: 'risk_direct_cost_cof',
    type: ['COF'],
    isHiddenColumn: false,
  },
  {
    id: '55',
    fieldKey: 'risk_business_loss_cof',
    type: ['COF'],
    isHiddenColumn: false,
  },
  {
    id: '66',
    fieldKey: 'risk_level_1_component',
    type: ['POF', 'COF'],
    isHiddenColumn: false,
  },
  {
    id: '77',
    fieldKey: 'risk_general_comments_cof',
    type: ['COF'],
    isHiddenColumn: false,
  },
  {
    id: '88',
    fieldKey: 'risk_damage_class',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '99',
    fieldKey: 'risk_safety_pof',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '111',
    fieldKey: 'risk_environment_pof',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '222',
    fieldKey: 'risk_public_impact_pof',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '333',
    fieldKey: 'risk_direct_cost_pof',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '444',
    fieldKey: 'risk_business_loss_pof',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '555',
    fieldKey: 'risk_general_comments_pof',
    type: ['POF'],
    isHiddenColumn: false,
  },
  {
    id: '666',
    fieldKey: 'risk_coating_system',
    type: ['TRANSITION_PERIOD'],
    isHiddenColumn: false,
  },
  {
    id: '777',
    fieldKey: 'risk_corrosivity_category',
    type: ['TRANSITION_PERIOD'],
    isHiddenColumn: false,
  },
  {
    id: '888',
    fieldKey: 'risk_structure_age',
    type: ['TRANSITION_PERIOD'],
    isHiddenColumn: false,
  },
  {
    id: '999',
    fieldKey: 'risk_cathodic_protection',
    type: ['TRANSITION_PERIOD'],
    isHiddenColumn: false,
  },
  {
    id: '1111',
    fieldKey: 'risk_transition_period',
    type: ['TRANSITION_PERIOD'],
    isHiddenColumn: false,
  },
  {
    id: '2222',
    fieldKey: 'risk_general_comments_transition_period',
    type: ['TRANSITION_PERIOD'],
    isHiddenColumn: false,
  },
];

export const colors: { [key: string]: string } = {
  AI: RC1,
  AII: RC1,
  AIII: RC2,
  AIV: RC3,
  BI: RC1,
  BII: RC1,
  BIII: RC3,
  BIV: RC4,
  CI: RC1,
  CII: RC2,
  CIII: RC3,
  CIV: RC4,
  DI: RC2,
  DII: RC3,
  DIII: RC4,
  DIV: RC4,
  EI: RC3,
  EII: RC4,
  EIII: RC4,
  EIV: RC4,
};
